import { combineReducers } from 'redux';
import contactWidgetReducer from './contact';
import reimbursementFiles from './files';
import initialData from './solutions';
import reimbursementForm from './form';
import requestStatus from './request';
import globalLoader from './globalLoader';
import checkAccount from './checkAccount';

export default combineReducers({
  contactWidgetReducer,
  initialData,
  reimbursementFiles,
  reimbursementForm,
  requestStatus,
  globalLoader,
  checkAccount,
});
